/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Notes_Incomplete_HintInputs */

const en_error_nav_notes_incomplete_hint = /** @type {(inputs: Error_Nav_Notes_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the notes and mark as complete if done.`)
};

const fr_error_nav_notes_incomplete_hint = /** @type {(inputs: Error_Nav_Notes_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoyez les notes et marquez-les comme terminees si fait.`)
};

const de_error_nav_notes_incomplete_hint = /** @type {(inputs: Error_Nav_Notes_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überprüfen Sie die Notizen und markieren Sie sie als erledigt, falls Sie sie bearbeitet haben.`)
};

const it_error_nav_notes_incomplete_hint = /** @type {(inputs: Error_Nav_Notes_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivedi le note e, se fatto, contrassegna come completato.`)
};

const ru_error_nav_notes_incomplete_hint = /** @type {(inputs: Error_Nav_Notes_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просмотрите заметки и отметьте как выполненные, если они сделаны.`)
};

const es_error_nav_notes_incomplete_hint = /** @type {(inputs: Error_Nav_Notes_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revise las notas y marque como completa si está hecho.`)
};

const zh_cn2_error_nav_notes_incomplete_hint = /** @type {(inputs: Error_Nav_Notes_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请检查笔记，如果已完成，请标记为已完成。`)
};

const ja_error_nav_notes_incomplete_hint = /** @type {(inputs: Error_Nav_Notes_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メモを確認し、完了した場合は完了としてマークします。`)
};

const hi_error_nav_notes_incomplete_hint = /** @type {(inputs: Error_Nav_Notes_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नोट्स की समीक्षा करें और पूरा हो जाने पर उसे पूर्ण के रूप में चिह्नित करें।`)
};

const pt_pt2_error_nav_notes_incomplete_hint = /** @type {(inputs: Error_Nav_Notes_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revise as anotações e marque como concluídas, se já as tiver terminado.`)
};

/**
* | output |
* | --- |
* | "Review the notes and mark as complete if done." |
*
* @param {Error_Nav_Notes_Incomplete_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_notes_incomplete_hint = /** @type {((inputs?: Error_Nav_Notes_Incomplete_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Notes_Incomplete_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_notes_incomplete_hint(inputs)
	if (locale === "de") return de_error_nav_notes_incomplete_hint(inputs)
	if (locale === "it") return it_error_nav_notes_incomplete_hint(inputs)
	if (locale === "ru") return ru_error_nav_notes_incomplete_hint(inputs)
	if (locale === "es") return es_error_nav_notes_incomplete_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_notes_incomplete_hint(inputs)
	if (locale === "ja") return ja_error_nav_notes_incomplete_hint(inputs)
	if (locale === "hi") return hi_error_nav_notes_incomplete_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_notes_incomplete_hint(inputs)
	return en_error_nav_notes_incomplete_hint(inputs)
});